import { useMutation } from 'react-query';
import notify from '../../../../../../../shared/feedback/notifications';
import { Translate } from '../../../../../../../shared/LanguageService';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { useTelemetryContext } from '../../../../../../../telemetry/telemetryContext';
import { getUserInfo } from '../../../../../../../telemetry/utils';
import ImageProcessingApi from '../../../api/ImageProcessingApi';

type DownloadImageMutationArgs = {
    orderId: number;
    user: AuthenticatedUser;
};

type DownloadableImage = {
    id: number;
    filename: string;
};

export function useDownloadImageMutation({ orderId, user }: DownloadImageMutationArgs) {
    let { logger } = useTelemetryContext();

    return useMutation(
        (image: DownloadableImage) =>
            image.filename.toLowerCase().endsWith('.dng')
                ? ImageProcessingApi.downloadDNGImage(orderId, image.id)
                : ImageProcessingApi.downloadImage(orderId, image.id),
        {
            onError: (error, image) => {
                logger.logException(error, {
                    origin: 'ImageEditorImageProcessingPage.Mutation.downloadImage',
                    userInfo: getUserInfo(user),
                    imageId: image.id
                });
                notify.failure(Translate('image-processing/button-label/download-images/error'));
            }
        }
    );
}
